import { BaseJsonSchema, createSchemaByBasicTypes } from "../../helpers";

export const IFvpAccompanyingContentOptions: BaseJsonSchema = {
  type: "object",
  properties: {
    type: createSchemaByBasicTypes("string", "accompanyingContent"),
    playerSelector: createSchemaByBasicTypes("string"),
    playerId: createSchemaByBasicTypes("string"),
    width: createSchemaByBasicTypes("string"),
    height: createSchemaByBasicTypes("string"),
    aspectRatio: createSchemaByBasicTypes("string"),
    mediaIds: {
      oneOf: [
        createSchemaByBasicTypes("string"),
        {
          type: "array",
          items: createSchemaByBasicTypes("string"),
        },
      ],
    },
    playlistId: createSchemaByBasicTypes("string"),
    mute: createSchemaByBasicTypes("boolean", true),
    volume: createSchemaByBasicTypes("number", 0.5, {
      minimum: 0,
      maximum: 1,
    }),
    byRecommender: createSchemaByBasicTypes("boolean", false),
    autoplay: {
      type: ["string", "boolean"],
      oneOf: [
        {
          type: "string",
          enum: ["viewable"],
        },
        {
          type: "boolean",
          enum: [true, false],
        },
      ],
      description:
        "Controls autoplay behavior. Can be true, false, or 'viewable' for viewability-based autoplay.",
      default: false,
    },
    autopause: createSchemaByBasicTypes("boolean", true),
    waitForScroll: {
      description:
        "Waits for window scroll event before initializing the player. Set as boolean to enable for all devices, or set as object to enable for specific devices [desktop, mobile]. Defaults to false.",
      anyOf: [
        {
          type: "object",
          properties: {
            desktop: createSchemaByBasicTypes("boolean"),
            mobile: createSchemaByBasicTypes("boolean"),
          },
        },
        {
          type: "boolean",
        },
      ],
    },
  },
  additionalProperties: false,
};
